import React, { useState } from 'react';
import { Tag, Check, X, Loader2 } from 'lucide-react';
import { validateDiscountCode, DiscountCode } from '../utils/discounts';
interface DiscountCodeInputProps {
  onApply: (discount: DiscountCode | null) => void;
  disabled?: boolean;
}
export function DiscountCodeInput({
  onApply,
  disabled = false
}: DiscountCodeInputProps) {
  const [code, setCode] = useState('');
  const [isValidating, setIsValidating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [appliedDiscount, setAppliedDiscount] = useState<DiscountCode | null>(null);
  const handleApply = async () => {
    if (!code.trim()) return;
    setIsValidating(true);
    setError(null);
    const result = await validateDiscountCode(code);
    setIsValidating(false);
    if (result.valid && result.discount) {
      setAppliedDiscount(result.discount);
      onApply(result.discount);
    } else {
      setError(result.message || 'Código inválido');
      setAppliedDiscount(null);
      onApply(null);
    }
  };
  const handleRemove = () => {
    setCode('');
    setAppliedDiscount(null);
    setError(null);
    onApply(null);
  };
  if (appliedDiscount) {
    return <div className="bg-green-50 border border-green-200 rounded-xl p-3 flex items-center justify-between" data-id="element-306">
        <div className="flex items-center gap-2" data-id="element-307">
          <div className="bg-green-100 p-1.5 rounded-full text-green-600" data-id="element-308">
            <Check className="w-4 h-4" data-id="element-309" />
          </div>
          <div data-id="element-310">
            <p className="text-sm font-bold text-green-800" data-id="element-311">
              Código aplicado: {appliedDiscount.code}
            </p>
            <p className="text-xs text-green-600" data-id="element-312">
              {appliedDiscount.discount_type === 'percentage' ? `-${appliedDiscount.discount_value}% de descuento en el subtotal` : `-${(appliedDiscount.discount_value / 100).toLocaleString('es-CO')} COP de descuento`}
            </p>
          </div>
        </div>
        <button type="button" onClick={handleRemove} disabled={disabled} className="text-gray-400 hover:text-red-500 transition-colors p-1" title="Quitar código" data-id="element-313">
          <X className="w-5 h-5" data-id="element-314" />
        </button>
      </div>;
  }
  return <div className="space-y-2" data-id="element-315">
      <label className="block text-sm font-semibold text-gray-700" data-id="element-316">
        ¿Tienes un código de descuento?
      </label>
      <div className="flex gap-2" data-id="element-317">
        <div className="relative flex-1" data-id="element-318">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-319">
            <Tag className="w-4 h-4 text-gray-400" data-id="element-320" />
          </div>
          <input type="text" value={code} onChange={e => {
          setCode(e.target.value.toUpperCase());
          setError(null);
        }} disabled={disabled || isValidating} placeholder="Ingresa tu código" className={`w-full pl-10 pr-4 py-2.5 rounded-xl border ${error ? 'border-red-300 focus:ring-red-500' : 'border-gray-300 focus:ring-brand-cyan'} focus:ring-2 focus:border-transparent outline-none transition-all uppercase`} onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleApply();
          }
        }} data-id="element-321" />
        </div>
        <button type="button" onClick={handleApply} disabled={!code.trim() || disabled || isValidating} className="bg-brand-navy hover:bg-[#1a2a8a] text-white px-4 py-2.5 rounded-xl font-bold transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center min-w-[100px]" data-id="element-322">
          {isValidating ? <Loader2 className="w-5 h-5 animate-spin" data-id="element-323" /> : 'Aplicar'}
        </button>
      </div>
      {error && <p className="text-sm text-red-500 font-medium" data-id="element-324">{error}</p>}
    </div>;
}